import { Injectable, inject, DestroyRef } from '@angular/core';
import { EventBusService, EventPayload } from 'src/app/shared/services/event-bus.service';
import { LocumsMarginCalculatorEvents } from '../enums/locums-margin-calculator-events.enum';
import { MarginSetupStore } from './margin-setup.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Injectable({ providedIn: 'root' })
export class MarginSetupReducer {
    private readonly eventBus = inject(EventBusService);
    private readonly marginSetupStore = inject(MarginSetupStore);
    private readonly destroy$ = inject(DestroyRef);

    constructor() {
        this.listenToMarginSetupEvent();
        this.listenToLoadMarginDetailsEvent();
    }

    private listenToLoadMarginDetailsEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.LOCUMS_1099_MARGIN_CALCULATOR_LOAD_MARGIN_DETAILS)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupFromData({
                    ...event.payload.marginDetails.marginSetUpDetails,
                    marginId: event.payload.marginDetails.marginId as number,
                    submittalId: event.payload.marginDetails.submittalDetails?.submittalId as number
                });
            });
    }

    private listenToMarginSetupEvent() {
        this.eventBus
            .on(LocumsMarginCalculatorEvents.IS_ALL_INCLUSIVE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ isAllInclusive: event.payload as boolean | null });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.CONTRACT_START_DATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ contractStartDate: event.payload as Date });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.CONTRACT_END_DATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ contractEndDate: event.payload as Date });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.DAYS_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ days: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.HOURS_PER_SHIFT_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ hoursPerShift: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.BILL_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ billRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.PAY_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ payRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.OVERTIME_BILL_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ overtimeBillRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.OVERTIME_PAY_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ overtimePayRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.OVERTIME_RATE_FACTOR_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ overtimeRateFactor: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.HOLIDAY_BILL_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ holidayBillRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.HOLIDAY_PAY_RATE_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ holidayPayRate: event.payload as number });
            });

        this.eventBus
            .on(LocumsMarginCalculatorEvents.HOLIDAY_RATE_FACTOR_CHANGED)
            .pipe(takeUntilDestroyed(this.destroy$))
            .subscribe((event: EventPayload) => {
                this.marginSetupStore.updateMarginSetupField({ holidayRateFactor: event.payload as number });
            });
    }
}
